import { BulkActionsPanel, Button, Form, Spacing, Table, Text } from '@approvalmax/ui/src/components';
import { LineItemsGroupEdit } from 'pages/requestForm/components/LineItemsGroupEdit/LineItemsGroupEdit';
import { useExpenseReportExpenseLines } from 'pages/requestForm/containers/netsuite/NetSuiteExpenseReportRequestForm/hooks';
import { memo } from 'react';

import {
    useActionMenuItems,
    useCheckedItems,
    useColumnsDefinition,
    useExpenseForm,
    useGroupManagement,
    useTableData,
} from './ExpenseSection.hooks';
import { messages } from './ExpenseSection.messages';

export const ExpenseSection = memo(() => {
    const { onAddLine, handleReorderRows } = useExpenseReportExpenseLines();
    const columnsDefinition = useColumnsDefinition();
    const {
        isGroupEditVisible,
        isGroupCloneVisible,
        isGroupRemoveVisible,
        isGroupEditPopupVisible,
        openGroupEdit,
        closeGroupEdit,
        handleGroupClone,
        handleGroupRemove,
        groupItems,
    } = useGroupManagement();
    const { checkedItems, handleCheckedItemsChange } = useCheckedItems();
    const tableData = useTableData();
    const actionMenuItems = useActionMenuItems<(typeof tableData)[number]>();
    const { form, handleFormChange } = useExpenseForm(tableData);

    return (
        <section>
            {checkedItems.length ? (
                <BulkActionsPanel
                    selectedItemsCount={checkedItems.length}
                    onEdit={isGroupEditVisible ? openGroupEdit : undefined}
                    onClone={isGroupCloneVisible ? handleGroupClone : undefined}
                    onDelete={isGroupRemoveVisible ? handleGroupRemove : undefined}
                    onClose={closeGroupEdit}
                />
            ) : (
                <Text font='headline' fontSize='xxsmall' fontWeight='medium' as='h2' spacing='16 0 16'>
                    {messages.sectionName}
                </Text>
            )}

            <Spacing height={8} />

            <Form form={form} onChange={handleFormChange}>
                <Table
                    columns={columnsDefinition}
                    data={tableData}
                    bordered
                    fontSize='small'
                    checkedItems={checkedItems}
                    onCheckedItemsChange={handleCheckedItemsChange}
                    onReorderRows={handleReorderRows}
                    reorderable
                    hoverable={false}
                    rowActionMenuItems={actionMenuItems}
                />
            </Form>

            <Spacing height={8} />

            <Button color='blue80' size='small' onClick={onAddLine}>
                {messages.addLine}
            </Button>

            {/* TODO: Will be redesigned in this ticket: https://approvalmax.atlassian.net/browse/AM-20441 */}
            {isGroupEditPopupVisible && <LineItemsGroupEdit onClose={closeGroupEdit} items={groupItems} />}
        </section>
    );
});

ExpenseSection.displayName = 'ExpenseSection';
